'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _deviceConstants = require('@wh/device-constants');

var device = (0, _deviceConstants.getDevice)(process.env);
/**
 * Dummy reducer. Defaults to mobile
 * @param {String} state A string being either mobile or desktop. This will likely evolve in the future
 * @return {String} The device
 */

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : device;
  return state;
};
//# sourceMappingURL=reducer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-device-detection/dist/main/reducer.js
// module id = 518
// module chunks = 0